// Creatures of the open world, and the few numbers combat runs on. Only the server rolls damage; the client
// reads this for names, levels and how big to draw the health bar.
import { Act, ATTACK_FRAME_TICKS, ATTACK_TICKS, type MoveState } from './sim.js';

export interface MobDef {
  id: string; name: string; level: number; hp: number;
  dmg: [number, number];       // per hit
  aggro: number;               // tiles: notices you and comes over; 0 = only fights back
  reach: number;               // pixels: how close it must be to hit
  attackEvery: number;         // ticks between its attacks
  run: boolean;                // runs when chasing (bunnies are quick)
  drops: { def: string; chance: number; qty: [number, number] }[];
  xp: number; respawnSec: number;
  speed: number;               // how fast its time bar fills in battle (players: 34)
  boss?: boolean;              // no running away
}

export const MOBS: Record<string, MobDef> = {
  puff: { id: 'puff', name: 'Puffball', level: 1, hp: 18, dmg: [1, 2], aggro: 0, reach: 18, attackEvery: 80, run: false,
    drops: [{ def: 'slime_gel', chance: 0.7, qty: [1, 2] }], xp: 8, respawnSec: 20, speed: 24 },
  bunny: { id: 'bunny', name: 'Meadow Bunny', level: 2, hp: 24, dmg: [1, 3], aggro: 0, reach: 18, attackEvery: 60, run: true,
    drops: [{ def: 'soft_tuft', chance: 0.6, qty: [1, 1] }, { def: 'herb', chance: 0.25, qty: [1, 1] }], xp: 11, respawnSec: 25, speed: 38 },
  beetle: { id: 'beetle', name: 'Bramble Beetle', level: 3, hp: 36, dmg: [2, 4], aggro: 3, reach: 20, attackEvery: 70, run: false,
    drops: [{ def: 'beetle_shell', chance: 0.55, qty: [1, 1] }, { def: 'mushroom', chance: 0.2, qty: [1, 1] }], xp: 16, respawnSec: 30, speed: 29 },
};
export const mobDef = (id: string | undefined) => (id ? MOBS[id] : undefined);

export const PLAYER_HP = 60;
/** How far a creature will follow you from where it lives before it gives up and wanders home. */
export const LEASH_TILES = 9;
/** Out of combat this long, you heal. */
export const REGEN_AFTER_TICKS = 60 * 4;

/** Your hit: a little stronger with a weapon in hand. */
export function playerDamage(weapon: string | null | undefined): [number, number] {
  return weapon === 'wooden_sword' ? [6, 9] : weapon ? [5, 8] : [4, 7];
}

/** The tick an attack lands: the strike frame of the swing. True once per attack. */
export const strikeNow = (m: MoveState): boolean => m.act === Act.Attack && m.actT === ATTACK_TICKS - ATTACK_FRAME_TICKS[1];

/** Flags on a combat event. */
export const HIT = { crit: 1, dodge: 2, kill: 4, heal: 8 } as const;
